import React from 'react'
import PropTypes from 'prop-types'

function Left({ children, ratio = 3 }) {
  return (
    <div className={`left col-lg-${ratio}`} id='split-view-left'>{children}</div>
  )
}

Left.propTypes = {
  children: PropTypes.element.isRequired,
  ratio: PropTypes.number,
}

export default Left
